import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "page-container profile-page-container" }
const _hoisted_2 = { class: "page-content" }
const _hoisted_3 = { class: "md:col-6 col-12" }
const _hoisted_4 = { class: "md:col-6 col-12 pr-0" }
const _hoisted_5 = {
  key: 0,
  class: "md:col-6 col-12 pr-0"
}

import { onBeforeMount } from 'vue';
import ProfileGeneral from './components/ProfileGeneral.vue';
import ProfileLocation from './components/ProfileLocation.vue';
import ProfileNotifications from './components/ProfileNotifications.vue';
import { can } from '@/composables';
import { PERMISSIONS } from '@/enum';
import { PersonStores } from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'Profile',
  setup(__props) {

const profileStore = PersonStores.useUserProfileStore();

onBeforeMount(async () => await profileStore.getAuthUserProfile());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "page-header" }, [
      _createElementVNode("h1", null, "Profile")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ProfileGeneral)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(ProfileLocation)
      ]),
      (_unref(can)([_unref(PERMISSIONS).NOTIFICATIONS_EMAIL_FORWARD, _unref(PERMISSIONS).NOTIFICATIONS_EVENT_REMINDER]))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(ProfileNotifications)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})